import { render, staticRenderFns } from "./chapter.vue?vue&type=template&id=16457c85&"
import script from "./chapter.vue?vue&type=script&lang=js&"
export * from "./chapter.vue?vue&type=script&lang=js&"
import style0 from "./chapter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports